import { useEffect, useState } from 'react';
import { AcButton, ErrorState, LoadingState } from '@/dashboard/ui';

// Frozen V14g: selected filename; saved file opens in the browser's own viewer.
// The parent supplies original bytes only after the existing audited read. No
// document scripts, parser, remote service or editable document source is mounted.
export default function ClinicalPdfPreview({ base64, label, filename, staged = false }: {
  base64: string; label: string; filename?: string; staged?: boolean;
}): JSX.Element {
  const [loaded, setLoaded] = useState<{ source: string; url: string | null } | null>(null);
  const [attempt, setAttempt] = useState(0);
  const current = loaded?.source === base64 ? loaded : null;
  useEffect(() => {
    if (staged) return;
    let url: string | null = null;
    try {
      const bytes = Uint8Array.from(atob(base64), char => char.charCodeAt(0));
      url = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
      setLoaded({ source: base64, url });
    } catch { setLoaded({ source: base64, url: null }); }
    return () => { if (url !== null) URL.revokeObjectURL(url); };
  }, [base64, staged, attempt]);
  return <section className="evidence-pdf" aria-label={label} data-testid="clinical-pdf-preview">
    <div className="evidence-pdf__file">
      <span>{filename?.trim() || 'File'}</span>
      {!staged && current?.url ? <> · <a href={current.url} target="_blank" rel="noopener noreferrer">Open file</a></> : null}
      {!staged && !current ? <LoadingState label="Preparing file…" lines={1} /> : null}
      {!staged && current?.url === null ? <ErrorState title="The file could not be opened." detail="Try loading the original file again."
        action={<AcButton size="sm" variant="secondary" onClick={() => setAttempt(value => value + 1)}>Retry open</AcButton>} /> : null}
    </div>
  </section>;
}
